/**
 * O primeiro nome de uma pessoa, o mesmo no chip da conta, na saudação da Visão
 * geral e na do chat: a primeira palavra do nome. Uma palavra com dígito é um
 * identificador (o UUID de um pool por e-mail, um apelido de token), nunca um
 * nome, e aí vale a parte local do e-mail. Sem nenhum dos dois (o /me ainda
 * viajando), vazio: quem chama decide como cumprimentar sem nome.
 */
export function firstName(displayName: string | null | undefined, email: string | null | undefined): string {
  const first = displayName?.trim().split(/\s+/)[0];
  if (first && !/\d/.test(first)) return first;
  return email?.split('@')[0] ?? '';
}
